exports.pbkdf2 = require('./lib/async')
exports.pbkdf2Sync = require('./lib/sync')



//////////////////
// WEBPACK FOOTER
// ./~/_pbkdf2@3.1.2@pbkdf2/browser.js
// module id = 86
// module chunks = 8